import "./SuvaiGallery.scss"
import { sortByOrderAscending } from "../../helper/helper";
import { useEffect } from "react";
import Button from "../../components/button/Button";
import { useSelector } from "react-redux";
const SuvaiGallery = () => {
    const pages = useSelector((state) => state.companyData.pages)
    const page = pages.find((page) => page.PageId === "gallery")
    const Components = page?.Components || []
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const getImages = (images) => {
        const result = [];
        for (let i = 0; i < images.length; i += 5) {
            result.push(images.slice(i, i + 5));
        }
        return result;
    };
    const getHeaderontent = (props) => {
        return (
            <div className="SuvaiGallery-header">
                <div className="SuvaiGallery-header-subtext">
                    {props.subHeaderText}
                </div>
                <div className="SuvaiGallery-header-text">{props.headerText}</div>
            </div>
        )
    }
    const getGalleryContent = (data) => {
        return (
            <div className="SuvaiGallery-gallery">
                {getImages(data).map((images, index) => (
                    <div
                        className={`SuvaiGallery-gallery-inner ${index % 2 === 0 ? "" : "reversed"}`}
                        key={index}
                    >
                        <div className="SuvaiGallery-gallery-inner-left">
                            <img src={images[0].src} alt="" />
                        </div>
                        <div className="SuvaiGallery-gallery-inner-right">
                            {images.slice(1).map((img, key) => (
                                <img src={img.src} alt="" key={key} />
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        )
    }
    const getcomponentFixedContainerComponents = (component) => {
        switch (component.ID) {
            case "SuvaiHome-MobileFixed-button":
                return <Button
                    text={component?.Props.btnText}
                    padding={component?.Props?.padding}
                    width={component?.Props.width}
                    type={component?.Props.type}
                    onClick={() => {
                        if (component?.Props?.href && component?.Props?.href !== "") {
                            window.open(component?.Props?.href, '_blank')
                        }
                    }} />
            default:
                return <div />
        }

    }
    const getcomponentFixedContainer = (components) => {
        return (<div className="SuvaiHome-MobileFixed">
            {sortByOrderAscending(components).map((component, key) => {
                return getcomponentFixedContainerComponents(component)
            })}
        </div>)
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "SuvaiGallery-header":
                return getHeaderontent(component.Props)
            case "SuvaiGallery-gallery":
                return getGalleryContent(component?.Data)
            case "SuvaiHome-MobileFixed":
                return getcomponentFixedContainer(component?.Components)

            default:
                return <div />
        }

    }
    return (
        <div className="SuvaiGallery">
            {sortByOrderAscending(Components).map((component, key) => {
                return getComponents(component)
            })}
        </div>
    );
};

export default SuvaiGallery;